<template>
  <section :class="flag?'tsName':''">
    <section>{{showValue}}</section>
    <section class="allTsName">{{value}}</section>
  </section>
</template>
<script>
export default {
  name: 'tsName',
  props: {
    'value': String
  },
  data () {
    return {
      showValue: '',
      flag: false
    }
  },
  created () {
    if (this.value && this.value.indexOf('、') >= 0) {
      this.showValue = this.value.split('、')[0] + '...'
      this.flag = true
    } else {
      this.showValue = this.value
    }
  }
}
</script>
<style scoped>
  .tsName {
    position: relative;
    cursor: pointer;
  }
  .allTsName {
    transform: scale(0.9);
    display: none;
    position: absolute;
    padding: 10px;
    -webkit-box-shadow: 1px 1px 1px 1px #ddd;
    box-shadow: 1px 1px 1px 1px #ddd;
    z-index: 99;
    background-color: #ffffff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .tsName:hover .allTsName {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/tsName.vue